import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketFeesDetailsTemplate from './BasketFeesDetailsTemplate';
import { rem } from 'polished';

export const BasketFeesDetailsStyled = styled(BasketFeesDetailsTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contentInner {
        padding-bottom: ${rem(30)};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
            padding-bottom: 0;
            text-align: left;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .title {
        font-size: ${rem('14px')};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding-bottom: ${rem(8)};
    }

    .description {
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        p {
            margin: ${rem('4px')} 0 0 0;
        }
    }

    .carteGriseInput {
        padding: 0 0 ${rem(32)} 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .description {
            padding-bottom: ${rem(15)};
        }

        .description,
        .postalCode {
            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }

            p {
                margin: 0;
            }
        }

        .postalCode {
            background: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.white};
            padding: ${rem(20)} ${rem(14)};

            @media (max-width: ${breakpoints.md}px) {
                margin-top: ${rem(14)};
            }

            &_title {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            &_warning {
                display: flex;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                align-items: center;
                margin: ${rem(10)} 0 0 0;

                .icon-wrapper {
                    margin-right: ${rem(10)};

                    svg {
                        width: ${rem(35)};
                        height: ${rem(35)};
                    }
                }
            }

            &_input {
                display: flex;
                align-items: center;
                padding-top: ${rem(14)};
                position: relative;

                .error {
                    position: absolute;
                    bottom: -${rem(13)};
                    color: ${({ theme }) => theme.colors.white};
                    font-size: ${({ theme }) => theme.fontSizes.textTiny};
                }

                input {
                    height: ${rem(40)};
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    width: 70%;
                    margin: 0 ${rem(10)} 0 0;
                    padding: ${rem(5)} ${rem(10)};
                    border: none;
                    color: ${({ theme }) => theme.colors.black};

                    &.warning {
                        border: 1px solid ${({ theme }) => theme.colors.danger};
                    }
                }

                button {
                    height: ${rem(40)};
                    background: none;
                    border: 1px solid white;
                    color: ${({ theme }) => theme.colors.white};
                    text-transform: uppercase;
                    font-size: ${({ theme }) => theme.fontSizes.textTiny};
                    padding: ${rem(5)} ${rem(20)};
                    cursor: pointer;

                    &:hover {
                        background: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                        color: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }
    }

    .carteGriseInformation {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        background: ${({ theme }) => theme.colors.grey8};
        padding: ${rem(15)} ${rem(20)};
        margin: ${rem(10)} 0;
    }

    .registrationFees {
    }

    .malusFees {
        padding-top: ${rem(40)};
    }

    .malusFeesSummary,
    .carteGriseSummary {
        margin-top: ${rem('32px')};

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .description,
        .summary {
            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }

        .summary {
            @media (min-width: ${breakpoints.md}px) {
                margin-left: ${rem(20)};
            }
        }

        .description {
            @media (max-width: ${breakpoints.md}px) {
                padding-bottom: ${rem(15)};
            }
        }
    }

    .summary {
        width: 100%;

        @media (min-width: ${breakpoints.md}px) {
            width: 50%;
        }

        .item {
            margin: 0;
            display: flex;
            justify-content: space-between;
            padding: ${rem(16)} 0;
            border-top: 1px solid ${({ theme }) => theme.colors.grey25};

            &:last-child {
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
            }

            button {
                border: none;
                cursor: pointer;
                background: none;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                text-decoration: underline;
                padding: 0;
            }
        }

        .noBorderTop {
            border-top: none !important;
        }

        .price {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }
    }
`;
